const CLOSE_WALL_MATERIAL = 'CLOSE_WALL_MATERIAL';

const WALL_MATERIAL_LOAD_REQUEST = 'WALL_MATERIAL_LOAD_REQUEST';
const WALL_MATERIAL_LOAD_SUCCESS = 'WALL_MATERIAL_LOAD_SUCCESS';
const WALL_MATERIAL_LOAD_ERROR = 'WALL_MATERIAL_LOAD_ERROR';

const WALL_MATERIAL_LIKE_REQUEST = 'WALL_MATERIAL_LIKE_REQUEST';
export const WALL_MATERIAL_LIKE_SUCCESS = 'WALL_MATERIAL_LIKE_SUCCESS';
const WALL_MATERIAL_LIKE_ERROR = 'WALL_MATERIAL_LIKE_ERROR';

const WALL_MATERIAL_DENOUNCE_REQUEST = 'WALL_MATERIAL_DENOUNCE_REQUEST';
export const WALL_MATERIAL_DENOUNCE_SUCCESS = 'WALL_MATERIAL_DENOUNCE_SUCCESS';
const WALL_MATERIAL_DENOUNCE_ERROR = 'WALL_MATERIAL_DENOUNCE_ERROR';

const WALL_MATERIAL_COMMENT_REQUEST = 'WALL_MATERIAL_COMMENT_REQUEST';
export const WALL_MATERIAL_COMMENT_SUCCESS = 'WALL_MATERIAL_COMMENT_SUCCESS';
const WALL_MATERIAL_COMMENT_ERROR = 'WALL_MATERIAL_COMMENT_ERROR';

const WALL_INCREMENT_VIEWS_REQUEST = 'WALL_INCREMENT_VIEWS_REQUEST';
const WALL_INCREMENT_VIEWS_SUCCESS = 'WALL_INCREMENT_VIEWS_SUCCESS';
const WALL_INCREMENT_VIEWS_ERROR = 'WALL_INCREMENT_VIEWS_ERROR';

import * as backend from 'backend-helpers/wallMaterial';

function sortComments(c1, c2) {
    return c1.id > c2.id ? -1 : 1;
}

export default function wallMaterial(state = {}, action) {
    if (action.type === WALL_MATERIAL_LOAD_REQUEST) {
        return {
            ...action.wallMaterial,
            isLoading: true
        }
    }

    if (action.type === WALL_MATERIAL_LOAD_SUCCESS) {
        let {wallMaterial} = action.result.data;

        wallMaterial.comments.sort(sortComments);

        return {
            ...wallMaterial,
            isLoading: false
        }
    }

    if (action.type === CLOSE_WALL_MATERIAL) {
        return initState;
    }

    if (action.type === WALL_MATERIAL_LIKE_SUCCESS) {
        if (state && state.id === action.id) {
            let {like_count} = action.result;

            return {
                ...state,
                is_liked: true,
                like_count
            }
        }
    }

    if (action.type === WALL_MATERIAL_DENOUNCE_SUCCESS) {
        if (state && state.id === action.id) {
            let {denounce_count, hidden} = action.result;

            return {
                ...state,
                is_denounced: true,
                denounce_count,
                hidden
            }
        }
    }

    if (action.type === WALL_MATERIAL_COMMENT_SUCCESS) {
        if (state && state.id === action.id) {
            let comments = [...state.comments, action.result.data.comment];
            comments.sort(sortComments);

            return {
                ...state,
                comments,
            }
        }
    }
    
    if (action.type === WALL_INCREMENT_VIEWS_SUCCESS) {
        return {
            ...state,
            views: action.result.data.views
        }
    }

    if (action.type === CLOSE_WALL_MATERIAL) {
        return initState;
    }

    return state;
}

export function openWallMaterial(params) {
    return {
        types: [WALL_MATERIAL_LOAD_REQUEST, WALL_MATERIAL_LOAD_SUCCESS, WALL_MATERIAL_LOAD_ERROR],
        promise: backend.getWallMaterial(params),
        wallMaterial
    }
}

export function closeWallMaterial() {
    return {
        type: CLOSE_WALL_MATERIAL
    }
}

export function likeWallMaterial({id}) {
    return {
        types: [WALL_MATERIAL_LIKE_REQUEST, WALL_MATERIAL_LIKE_SUCCESS, WALL_MATERIAL_LIKE_ERROR],
        promise: backend.likeWallMaterial({id}),
        id
    }
}

export function denounceWallMaterial({id}) {
    return {
        types: [WALL_MATERIAL_DENOUNCE_REQUEST, WALL_MATERIAL_DENOUNCE_SUCCESS, WALL_MATERIAL_DENOUNCE_ERROR],
        promise: backend.denounceWallMaterial({id}),
        id
    }
}

export function incrementWallItemViews(id) {
    return {
        types: [WALL_INCREMENT_VIEWS_REQUEST, WALL_INCREMENT_VIEWS_SUCCESS, WALL_INCREMENT_VIEWS_ERROR],
        promise: backend.incrementAmateurFilmViews(id),
        id
    }
}



// WEBPACK FOOTER //
// ./src/reducers/wallMaterial.js